import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { authAPI } from "../lib/api";

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("usg_user");
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("usg_token");
    if (token) {
      authAPI.me()
        .then((res) => {
          setUser(res.data);
          localStorage.setItem("usg_user", JSON.stringify(res.data));
        })
        .catch(() => {
          localStorage.removeItem("usg_token");
          localStorage.removeItem("usg_user");
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem("usg_token", res.data.token);
    localStorage.setItem("usg_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  }, []);

  const register = useCallback(async (data) => {
    const res = await authAPI.register(data);
    localStorage.setItem("usg_token", res.data.token);
    localStorage.setItem("usg_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("usg_token");
    localStorage.removeItem("usg_user");
    setUser(null);
  }, []);

  const markOnboarded = useCallback(async () => {
    await authAPI.markOnboarded();
    setUser((prev) => {
      const updated = { ...prev, onboarded: true };
      localStorage.setItem("usg_user", JSON.stringify(updated));
      return updated;
    });
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, markOnboarded }}>
      {children}
    </AuthContext.Provider>
  );
};
